import React, {useState,useEffect,useRef} from 'react'
import { Formik, Field } from 'formik'
import { Step, Modal, Message } from 'semantic-ui-react'
import {WindowReload, WindowURL, WindowLocation,CompanyName} from '../../config/settings'
import Alertmessage from '../../config/alert'
import axios from 'axios'

import OpenAccountStep1 from './steps1'
import OpenAccountStep2 from './steps2'
import OpenAccountStep3 from './steps3'

import OpenAccountStep4Individual from './steps4_individual'
import OpenAccountStep4Joints from './steps4_joints'

import OpenAccountStep5Financials from './steps5_financial'
import OpenAccountDocument from './steps6_document'


export default function AppForm(props) {


	function ScrollToElement() {
	  var elmnt = document.getElementById("ElementScroll");
	  elmnt.scrollIntoView();
	}


	const [alert,setalert] = useState(false);
	const [Alertcontent,setAlertcontent] = useState({});
	function Alertclose(){setalert(false);}
	function Alertconfirm(data){if(data.confirm==true){setalert(false);}}
	function Alertdelete(data){
		if(data.delete==true){
		}
	}



	const [step, setstep] = useState(1);
	function ActiveStep(data){
		if(data==7){
			setstep(1);
		}else{
			setstep(data);
		}
		ScrollToElement();
	}
	const [state, setstate] = useState({

		//step 1
		reps_id:'',
		first_name:'',
		last_name:'',
		middle_name:'',
		primary_number:'',
		country:'',
		email:'',

		//step2
		username:'',
		password:'',
		confirm_password:'',
		secquestion_1:'',
		secquestion_1_answer:'',


		//step 3
		trading_1:0,
		trading_2:0,
		trading_3:0,
		trading_4:0,
		account_type:0,

		//step41
		date_birth_options:'1',
		date_birth:'',
		date_birth_text:'',
		citizenship:'1',
		citizen_country:'',
		type_id:'',
		id_number:'',
		address1:'',
		address2:'',
		city:'',
		state:'',
		postal_code:'',
		primary_number:'',
		home_number:'',
		cellular_number:'',
		fax:'',
		marital_status:'',
		no_dependents:'',

		//step42
		joint_first_name:'',
		joint_middle_name:'',
		joint_last_name:'',
		joint_date_birth_options:'1',
		joint_date_birth:'',
		joint_date_birth_text:'',
		joint_citizenship:'1',
		joint_citizen_country:'',
		joint_type_id:'',
		joint_id_number:'',
		joint_address1:'',
		joint_address2:'',
		joint_city:'',
		joint_state:'',
		joint_country:'',
		joint_postal_code:'',
		joint_primary_number:'',
		joint_home_number:'',
		joint_cellular_number:'',
		joint_fax:'',
		joint_email:'',
		joint_marital_status:'',
		joint_no_dependents:'',

		//step financial
		years_stock:'',
		years_options:'',
		years_mutual:'',
		years_futures:'',
		years_forex:'',
		ave_stock:'',
		ave_options:'',
		ave_mutual:'',
		ave_futures:'',
		ave_forex:'',
		rate_stock:'',
		rate_options:'',
		rate_mutual:'',
		rate_futures:'',
		rate_forex:'',
		finance_annual:'',
		finance_marginal:'',
		finance_totalnet:'',
		finance_liquidnet:'',
		finance_sourceincome:'',
		number_contracts:'',
		name_contracts:'',
		finance_amount:'',
		finance_fund:'',
		account_type:'',
		specify_finance_liquidnet:'',
		specify_finance_totalnet:'',
		specify_finance_annual:'',

		//document
		upload_document:'',
		captcha_text:'',
		captcha_value:'',
		captcha_show:'',
		file:''

	});

	function CallbackStateStep1(data){
		 setstate({
			 ...state,
			  reps_id:data.reps_id,
		 		first_name:data.first_name,
		 		last_name:data.last_name,
		 		middle_name:data.middle_name,
		 		primary_number:data.primary_number,
		 		country:data.country,
		 		email:data.email,
		 });
	}

	function CallbackStateStep2(data){
		 setstate({
			 ...state,
				username:data.username,
				password:data.password,
				secquestion_1:data.secquestion_1,
				secquestion_1_answer:data.secquestion_1_answer,
		 });
	}

	function CallbackStateStep3(data){
		 setstate({
			 ...state,
			 trading_1:data.trading_1,
			 trading_2:data.trading_2,
			 trading_3:data.trading_3,
			 trading_4:data.trading_4,
			 account_type:data.account_type,
		 });
	}


	function CallbackStateStep41(data){
		setstate({
			...state,
			reps_id:data.reps_id,
			first_name:data.first_name,
			middle_name:data.middle_name,
			last_name:data.last_name,
			date_birth_options:data.date_birth_options,
			date_birth:data.date_birth,
			date_birth_text:data.date_birth_text,
			citizenship:data.citizenship,
			citizen_country:data.citizen_country,
			type_id:data.type_id,
			id_number:data.id_number,
			address1:data.address1,
			address2:data.address2,
			city:data.city,
			state:data.state,
			country:data.country,
			postal_code:data.postal_code,
			primary_number:data.primary_number,
			home_number:data.home_number,
			cellular_number:data.cellular_number,
			fax:data.fax,
			email:data.email,
			marital_status:data.marital_status,
			no_dependents:data.no_dependents,
		});
	}


	function CallbackStateStep42(data){
		setstate({
			...state,
			reps_id:data.reps_id,
			first_name:data.first_name,
			middle_name:data.middle_name,
			last_name:data.last_name,
			date_birth_options:data.date_birth_options,
			date_birth:data.date_birth,
			date_birth_text:data.date_birth_text,
			citizenship:data.citizenship,
			citizen_country:data.citizen_country,
			type_id:data.type_id,
			id_number:data.id_number,
			address1:data.address1,
			address2:data.address2,
			city:data.city,
			state:data.state,
			country:data.country,
			postal_code:data.postal_code,
			primary_number:data.primary_number,
			home_number:data.home_number,
			cellular_number:data.cellular_number,
			fax:data.fax,
			email:data.email,
			marital_status:data.marital_status,
			no_dependents:data.no_dependents,

			joint_first_name:data.joint_first_name,
			joint_middle_name:data.joint_middle_name,
			joint_last_name:data.joint_last_name,
			joint_date_birth_options:data.joint_date_birth_options,
			joint_date_birth:data.joint_date_birth,
			joint_date_birth_text:data.joint_date_birth_text,
			joint_citizenship:data.joint_citizenship,
			joint_citizen_country:data.joint_citizen_country,
			joint_type_id:data.joint_type_id,
			joint_id_number:data.joint_id_number,
			joint_address1:data.joint_address1,
			joint_address2:data.joint_address2,
			joint_city:data.joint_city,
			joint_state:data.joint_state,
			joint_country:data.joint_country,
			joint_postal_code:data.joint_postal_code,
			joint_primary_number:data.joint_primary_number,
			joint_home_number:data.joint_home_number,
			joint_cellular_number:data.joint_cellular_number,
			joint_fax:data.joint_fax,
			joint_email:data.joint_email,
			joint_marital_status:data.joint_marital_status,
			joint_no_dependents:data.joint_no_dependents,


		});
	}


	function CallbackStateFinancial(data){
		setstate({
			...state,
			years_stock:data.years_stock,
			years_options:data.years_options,
			years_mutual:data.years_mutual,
			years_futures:data.years_futures,
			years_forex:data.years_forex,
			ave_stock:data.ave_stock,
			ave_options:data.ave_options,
			ave_mutual:data.ave_mutual,
			ave_futures:data.ave_futures,
			ave_forex:data.ave_forex,
			rate_stock:data.rate_stock,
			rate_options:data.rate_options,
			rate_mutual:data.rate_mutual,
			rate_futures:data.rate_futures,
			rate_forex:data.rate_forex,
			finance_annual:data.finance_annual,
			finance_marginal:data.finance_marginal,
			finance_totalnet:data.finance_totalnet,
			finance_liquidnet:data.finance_liquidnet,
			finance_sourceincome:data.finance_sourceincome,
			number_contracts:data.number_contracts,
			name_contracts:data.name_contracts,
			finance_amount:data.finance_amount,
			finance_fund:data.finance_fund,
			account_type:data.account_type,
			specify_finance_liquidnet:data.specify_finance_liquidnet,
			specify_finance_totalnet:data.specify_finance_totalnet,
			specify_finance_annual:data.specify_finance_annual,
		});
	}


	function CallbackStateStep5(data){
		 setstate({
			 ...state,
			  years_stock:data.years_stock,
	 			years_options:data.years_options,
	 			years_mutual:data.years_mutual,
	 			years_futures:data.years_futures,
	 			years_forex:data.years_forex,
	 			ave_stock:data.ave_stock,
	 			ave_options:data.ave_options,
	 			ave_mutual:data.ave_mutual,
	 			ave_futures:data.ave_futures,
	 			ave_forex:data.ave_forex,
	 			rate_stock:data.rate_stock,
	 			rate_options:data.rate_options,
	 			rate_mutual:data.rate_mutual,
	 			rate_futures:data.rate_futures,
	 			rate_forex:data.rate_forex,
	 			finance_annual:data.finance_annual,
	 			finance_marginal:data.finance_marginal,
	 			finance_totalnet:data.finance_totalnet,
	 			finance_liquidnet:data.finance_liquidnet,
	 			finance_sourceincome:data.finance_sourceincome,
	 			number_contracts:data.number_contracts,
	 			name_contracts:data.name_contracts,
	 			finance_amount:data.finance_amount,
	 			finance_fund:data.finance_fund,
	 			specify_finance_liquidnet:data.specify_finance_liquidnet,
	 			specify_finance_totalnet:data.specify_finance_totalnet,
	 			specify_finance_annual:data.specify_finance_annual,
		 });
	}

	function CallbackStateStep6(data){
		 setstate({
			 ...state,
			  upload_document:data.upload_document,
	 			captcha_text:data.captcha_text,
	 			captcha_value:data.captcha_value,
	 			captcha_show:data.captcha_show,
	 			file:data.upload_document,
		 });
		 SubmitApplication(state,data.upload_document);
	}



  const [state_error, setstate_error] = useState([]);
	const [modal, setmodal] = useState(false);
	function SubmitApplication(data,file){

		setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Processing',html:"This won't take long, please wait...",footer:'none'}});
		setalert(true);

		let formData = new FormData();
		formData.append('type','submit_application');
		formData.append('info',JSON.stringify(data));
		formData.append('file',file);
		axios.post('/application/request.php',formData)
		.then(function (response) {

			let obj = response.data;

			if(obj=='success'){
				setAlertcontent({intent:'alert',settings:{centered:false,icon:'success',title:'Congratulations!',html:"Application form successfully submitted."}});
				setalert(true);
				setTimeout(function() {WindowReload();},3000);
				return false;
			}

			if(obj=='error'){
				setAlertcontent({intent:'alert',settings:{centered:false,icon:'error',title:'Saving Error!',html:"Data not successfully processed. Please try again later."}});
				setalert(true);
				setTimeout(function() {WindowReload();},2000);
				return false;
			}

		  setstate_error(obj);
			setmodal(true);
			setTimeout(function() {setalert(false);},2000);

		})
		.catch(function (error){
			setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error!',html:"Problem connecting to the server. Contact the administrator.",footer:'yes'}});
			setalert(true);
			setTimeout(function() {WindowReload();},2000);
		});
 }

 function CallbackModal(){
	setmodal(false);
	setstep(6);
 }


 /*const [state_error, setstate_error] = useState([]);
 function ErrorsBelow(){
	 let formData = new FormData();
	 formData.append('type','error_fetch');
	 axios.post('/application/request.php',formData)
	 .then(function (response) {
		 let obj = response.data;
		 setstate_error(obj);
	 })
	 .catch(function (error){
	 });
 }

 useEffect(()=>{
	  ErrorsBelow();
 },[]);*/

	return (
		<React.Fragment>

			 {modal&&<Modal
				 onClose={() => CallbackModal(false)}
				 open={true}
				 content=<Message negative visible>
 			    <Message.Header>ERROR MESSAGE</Message.Header>
 			    <Message.List>
 						{Object.keys(state_error).map(function(keyName, keyIndex) {
 				    		return (
 				      			<Message.Item key={keyIndex}>{keyName}</Message.Item>
 				    		)
 						})}
 			    </Message.List>
 			  </Message>
				/>}

				<div className="stepwrapper">
				 <Step.Group unstackable ordered widths={6}>
						<Step active disabled={step==1}><Step.Content></Step.Content></Step>
						<Step active disabled={step==2}><Step.Content></Step.Content></Step>
						<Step active disabled={step==3}><Step.Content></Step.Content></Step>
						<Step active disabled={(step==41||step==42)}><Step.Content></Step.Content></Step>
						<Step active disabled={step==5}><Step.Content></Step.Content></Step>
						<Step active disabled={step==6}><Step.Content></Step.Content></Step>
					</Step.Group>
				</div>

		    {alert&&<Alertmessage close={Alertclose} data={Alertcontent} confirm={Alertconfirm} delete={Alertdelete}/>}
				{step==1&&<OpenAccountStep1 state={state} callstate={CallbackStateStep1} active={ActiveStep}/>}
				{step==2&&<OpenAccountStep2 state={state} callstate={CallbackStateStep2} active={ActiveStep}/>}
				{step==3&&<OpenAccountStep3 state={state} callstate={CallbackStateStep3} active={ActiveStep}/>}
				{step==41&&<OpenAccountStep4Individual state={state} callstate={CallbackStateStep41} active={ActiveStep}/>}
				{step==42&&<OpenAccountStep4Joints state={state} callstate={CallbackStateStep42} active={ActiveStep}/>}
				{step==5&&<OpenAccountStep5Financials state={state} callstate={CallbackStateStep5} active={ActiveStep}/>}
				{step==6&&<OpenAccountDocument state={state} callstate={CallbackStateStep6} active={ActiveStep}/>}

    </React.Fragment>
  )
}
